import {useBreadcrumbsStore} from 'entities/breadcrumbs';
import {DiaryHead, DiaryTable} from 'features/diary';
import {useEffect} from 'react';
import {useDiary} from '../lib/useDiary';
import {useGlobalStore} from 'entities/global';
import {useSearchParams} from 'react-router-dom';
import {ApiaryHivesAbsence} from '../../../shared/ui/apiaryHivesAbsence/ApiaryHivesAbsence.tsx';

export const Diary = () => {
  const setCrumbs = useBreadcrumbsStore((s) => s.setCrumbs);
  const setPlusButtonCallback = useGlobalStore((s) => s.setPlusButtonCallback);
  const [searchParams, setSearchParams] = useSearchParams();

  const {hives, setIsNewEntrieOpen} = useDiary();

  useEffect(() => {
    setCrumbs([
      {title: 'Моя пасека', url: '/', route: {path: '/'}},
      {title: 'Журнал пчеловода', url: '/diary', route: {path: '/diary'}},
    ]);

    setPlusButtonCallback(() => setIsNewEntrieOpen(true));

    return () => {
      setPlusButtonCallback(null);
    };
  }, []);

  return (
    <>
      <DiaryHead hives={hives} onNewEntrieClick={() => setIsNewEntrieOpen(true)} />

      <ApiaryHivesAbsence>
        <DiaryTable
          onNewEntrieClick={() => setIsNewEntrieOpen(true)}
          entryIdFromUrl={searchParams.get('id') || undefined}
          onEntryOpen={() => {
            searchParams.delete('id');
            setSearchParams(searchParams, {replace: true});
          }}
        />
      </ApiaryHivesAbsence>
    </>
  );
};
